// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__31DJn","upload":"Small_upload__P7T28","imageWrap":"Small_imageWrap__23UbQ","removeBtn":"Small_removeBtn__24Rs4"};